import jwt_decode from 'jwt-decode'

export function getClientAccountId() {
  const token = globalThis.localStorage.getItem('token') || ''
  if (!token) return ''
  try {
    const decoded = jwt_decode(token)
    return decoded?.clientAccountId || decoded?.legacy_id || ''
  } catch {
    return ''
  }
}

export function getActiveClientAccountId() {
  try {
    return globalThis.localStorage.getItem('clientAccountId') || getClientAccountId()
  } catch {
    return getClientAccountId()
  }
}
